/**
 * Standard grid layout configurations for Cloudscape Grid component
 * 
 * These configurations provide consistent responsive layouts across components.
 * All layouts stack to full-width (12 columns) on mobile, then split at 's' breakpoint.
 */

import type { GridProps } from '@amzn/awsui-components-core/grid';

/**
 * Two equal columns (50/50 split)
 * Mobile: Stacked | Desktop: Side-by-side
 */
export const GRID_TWO_COLUMN_EQUAL: GridProps['gridDefinition'] = [
  { colspan: { default: 12, s: 6 } },
  { colspan: { default: 12, s: 6 } }
];

/**
 * Two columns with left emphasis (40/60 split)
 * Mobile: Stacked | Desktop: Narrower left, wider right
 */
export const GRID_TWO_COLUMN_LEFT_NARROW: GridProps['gridDefinition'] = [
  { colspan: { default: 12, s: 5 } },
  { colspan: { default: 12, s: 7 } }
];

/**
 * Two columns with right emphasis (60/40 split)
 * Mobile: Stacked | Desktop: Wider left, narrower right
 */
export const GRID_TWO_COLUMN_RIGHT_NARROW: GridProps['gridDefinition'] = [
  { colspan: { default: 12, s: 7 } },
  { colspan: { default: 12, s: 5 } }
];

/**
 * Single full-width column
 */
export const GRID_SINGLE_COLUMN: GridProps['gridDefinition'] = [
  { colspan: 12 }
];

/**
 * Generate equal-width columns dynamically
 * @param columnCount Number of columns (2-4 recommended)
 */
export const createEqualColumns = (columnCount: number): GridProps['gridDefinition'] => {
  return Array(columnCount).fill({ 
    colspan: { default: 12, s: 12 / columnCount } 
  });
};
